import { useContext } from 'react';
import useTabName from 'src/hooks/useTabName';
/* CONTEXT */
import { CommonContext, NotificationsContext } from 'components/AuthenticatedApp/AuthenticatedApp';
import { withAspen } from 'components/aspen/withAspen';
import PushNotificationsAspen from './Aspen/PushNotifications';
import NotificationsPanel from './NotificationsPanel';
/* CONSTANTS */
import { TAB_CLIPS, TAB_EVENTS, TAB_VIDEO } from 'vd-constants';
/* HOOK */
import { useWindowSize } from '@solinkcorp/solink-components';
import useLocale from 'src/hooks/useLocale';

const PushNotifications = (props) => {
  const { loading } = useContext(NotificationsContext);
  const { width } = useWindowSize();
  const {
    authData: { isImpersonating },
  } = useContext(CommonContext);
  const locale = useLocale();
  const tabName = useTabName();

  const useDarkTheme = tabName === TAB_VIDEO && !(tabName === TAB_EVENTS || tabName === TAB_CLIPS);

  return (
    <NotificationsPanel
      {...props}
      useDarkTheme={useDarkTheme}
      isImpersonating={isImpersonating}
      isLoading={loading}
      locale={locale}
      windowWidth={width}
    />
  );
};

/** The notifications panel's only legacy/Aspen decision. */
export default withAspen(PushNotifications, PushNotificationsAspen);
